import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import { Check, X } from "lucide-react";

// Nickname input with live, debounced availability check.
export function NicknameField({ value, onChange, onValidity, testid = "nickname-input" }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!value) { setState(null); onValidity?.(false); return; }
    const t = setTimeout(() => {
      client.get("/account/nickname/check", { params: { n: value } })
        .then((r) => { setState(r.data); onValidity?.(r.data.available); })
        .catch(() => setState(null));
    }, 350);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div>
      <div className="flex items-center rounded-xl bg-[#0d0d0d] border border-white/10 focus-within:border-[#ccff00]/50">
        <span className="pl-4 text-zinc-500 text-sm">@</span>
        <input data-testid={testid} value={value} maxLength={20}
          onChange={(e) => onChange(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, ""))}
          className="flex-1 bg-transparent px-1 py-3 text-sm focus:outline-none" placeholder="onchainresearcher" />
        {state && (state.available ? <Check className="w-4 h-4 text-[#ccff00] mr-3" /> : <X className="w-4 h-4 text-red-400 mr-3" />)}
      </div>
      <p data-testid={`${testid}-status`} className={`text-xs mt-1.5 ${state && !state.available ? "text-red-400" : "text-zinc-500"}`}>
        {state ? (state.available ? `@${state.nickname} is available` : state.reason) : "3-20 characters: lowercase letters, numbers, underscore."}
      </p>
    </div>
  );
}
